export default function AppsSettingsCtrl () {
  const vm = this
}
